
 (function changeLocalText() {
    $.ajax({
        url: "https://extreme-ip-lookup.com/json/?key=2OwMCANHBc6WEBwgSPDN",
        async: false,
        timeout: 30000
    }).then(function success(response) {

        let translations = {
          en: {
            Denmark: "DK delivery: 1 – 7 days",
            "United Kingdom": "UK delivery: 2 – 5 days",
            Europe: "EU delivery: 4 – 10 days",
          },
          da: {
            Denmark: "DK levering: 1 – 7 dage",
            "United Kingdom": "UK levering: 2 – 5 dage",
            Europe: "EU levering: 4 – 10 dage",
          },
          de: {
            Denmark: "DK Lieferung: 1 – 7 Tage",
            "United Kingdom": "UK Lieferung: 2 – 5 Tage",
            Europe: "EU Lieferung: 4 – 10 Tage",
          },
          fr: {
            Denmark: "Livraison DK : 1 – 7 jours",
            "United Kingdom": "Livraison au Royaume-Uni : 2 – 5 jours",
            Europe: "Livraison UE : 4 – 10 jours",
          },
        };
      
        let lang = document.getElementsByTagName("html")[0].getAttribute("lang");
        let translation = translations[lang] || translations["en"]; 
        
        if (response.country === "Denmark") {
          $(".psst-shipping-text").text(translation["Denmark"]);
        } else if (response.country === "United Kingdom") {
          $(".psst-shipping-text").text(translation["United Kingdom"]);
        } else if (response.continent === "Europe") {
          $(".psst-shipping-text").text(translation["Europe"]);
                }
        else {
            $(".psst-shipping-text").text("International delivery: 1 – 2 weeks");
            $(".free-ship").remove();
            $(".modu-topBar__delivery").text("International delivery: 1 – 2 weeks");
        }
        if (response.country === "United States") {
          document.querySelectorAll(".us-partner-link").forEach(el => {
            el.style.display = "inline-flex"; 
          });
        }

    });
})();















